/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
//Standard libraries
import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Chip from "@material-ui/core/Chip";
import { Divider, Grid, Typography } from "@material-ui/core";
//custom libraries
import { BackButton, Button } from "../components";
import * as ROUTES from "../constants/routes";
import {
  FORM_FIELD_ORDER_DATE_FROM,
  FORM_FIELD_ORDER_DATE_TO,
} from "../constants/common";

export interface FilterJson {
  name: string;
  value: string;
}

export default function SearchFilterChipsSidebar({
  removeChip,
  chips,
  showForm,
  name,
  setShowForm,
  chipTextMap,
  ...props
}: any) {
  const { t } = useTranslation();
  function textNode(k: any, v: any) {
    let value = v;
    if (k === FORM_FIELD_ORDER_DATE_TO || k === FORM_FIELD_ORDER_DATE_FROM) {
      value = v.split(" ")[0];
    }
    return (
      <>
        <b>{t(chipTextMap[k])}: </b>
        <span> {" " + value}</span>
      </>
    );
  }
  return (
    <Grid container direction="column" spacing={2}>
      <Grid item>
        <Link className="icon-text" to={ROUTES.DASHBOARD}>
          <BackButton label={t("Common.BackToLanding")} />
        </Link>
      </Grid>

      <Grid item>
        <Typography variant="h1">{name} </Typography>
      </Grid>
      <Grid item>
        <Button
          fullWidth
          variant="outlined"
          onClick={() => setShowForm(true)}
          color="primary"
          name="Edit Search">
          {t("OrderManagement.editSearch")}
        </Button>
      </Grid>
      <Grid item>
        <Divider />
      </Grid>

      <Grid item>
        {Object.entries(chips).length > 0 && (
          <Typography variant="h3">
            {t("OrderManagement.SearchFilterApplied")}
          </Typography>
        )}
      </Grid>

      {Object.entries(chips).length > 0 &&
        Object.entries(chips).map(([k, v]) => (
          <Grid key={k} item>
            <Chip
              onDelete={(e) => {
                removeChip(k);
              }}
              variant="outlined"
              label={textNode(k, v)}
            />
          </Grid>
        ))}
    </Grid>
  );
}
